import { useTranslation } from 'react-i18next';

import Card from 'common/Card';
import FEATURES_CONFIG from 'config/features';
import getLoyaltyIcon from 'pages/Checkout/helpers/loyalty.utils';
import { prettifyPrice } from 'utils/price.util';

import * as S from './LoyaltyEarnedPoints.style';

const LoyaltyEarnedPoints: React.FC<{
  earnedPoints: number;
}> = ({ earnedPoints }) => {
  const { t } = useTranslation();
  const { loyaltyIcon } = FEATURES_CONFIG.settings;
  const Icon = getLoyaltyIcon(loyaltyIcon);

  return (
    <>
      <Card variant="scattered" testId="loyalty-earned-points">
        <S.IconWrapper>
          <Icon testid={loyaltyIcon} size="CUSTOM" />
          <S.EarnedPointsText>{t('orderSummaryPointsEarned')}</S.EarnedPointsText>
        </S.IconWrapper>

        <S.Points>
          {prettifyPrice(earnedPoints)} {t('orderConfirmation.points')}
        </S.Points>
      </Card>
    </>
  );
};

export default LoyaltyEarnedPoints;
